import React from "react";
import { Link } from "react-router-dom";
import { Tag, Dropdown, Space } from "antd";
import { TbDotsVertical } from "react-icons/tb";
import { useSelector } from "react-redux";

const AllCustomerCard = ({ data = [], setdetails, setmodal, setRefresh }) => {
  const { role } = useSelector((state) => state.userDetails);

  return (
    <div className="md:hidden grid grid-cols-1 gap-4">
      {data.map((item, index) => (
        <div key={index} className="border rounded-md p-4 shadow-sm">
          <div className="flex justify-between items-center mb-3">
            <div>
              <h3 className="font-medium text-lg capitalize">
                {`${item?.firstname} ${item.lastname}` ?? "-Nil-"}
              </h3>
              <p className="text-gray-600 text-sm">{item.customerid}</p>
            </div>
            <Dropdown
              menu={{
                items: [
                  {
                    key: "1",
                    label: (
                      <Link
                        to={`/meter-details/${item.customerid}/${item.meter}`}
                        className="text-[12px]"
                      >
                        View details
                      </Link>
                    ),
                  },
                  {
                    key: "2",
                    disabled: role === "Customer Manager" ? false : true,
                    label: (
                      <div
                        className="text-[12px]"
                        onClick={() => {
                          setdetails(item);
                          setmodal(true);
                        }}
                      >
                        Unassign meter
                      </div>
                    ),
                  },
                ],
              }}
              placement="bottom"
              arrow
            >
              <a onClick={(e) => e.preventDefault()}>
                <Space>
                  <TbDotsVertical color="black" />
                </Space>
              </a>
            </Dropdown>
          </div>

          <div className="grid grid-cols-2 gap-2 mb-3">
            <div className="border-r pr-2">
              <p className="text-gray-500 text-xs">Meter Number</p>
              <Link
                to={`/meter-details/${item?.customerid}/${item?.meter}`}
                className="underline"
              >
                <Tag color={"geekblue"} key={item.meter}>
                  {item?.meter}
                </Tag>
              </Link>
            </div>
            <div>
              <p className="text-gray-500 text-xs">Assigned By</p>
              <p className="text-sm">{item?.assigner ?? "-Nil-"}</p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-2">
            <div className="border-r pr-2">
              <p className="text-gray-500 text-xs">Customer Type</p>
              <p className="text-sm">{item?.customertype ?? "-Nil-"}</p>
            </div>
            <div>
              <p className="text-gray-500 text-xs">Address</p>
              <p className="text-sm truncate">{item?.address ?? "-Nil-"}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AllCustomerCard;
